import { createContext } from 'react';
import type { Dispatch } from 'react';

import { initialAction, initialState } from './initial';

const CategoryValueContext = createContext<typeof initialState>(initialState);

const CategoryActionContext = createContext<Dispatch<typeof initialAction>>(
  () => {},
);

export { CategoryActionContext, CategoryValueContext };
